import { http } from "../http/Http";
import { WeightUnit } from "../models/WeightUnit";
import { ServiceResponse } from "../models/ServiceResponse";

export class WeightUnitService {

    getWeightUnits = async (): Promise<ServiceResponse<WeightUnit[]>> => {
        const { data } = await http.get<ServiceResponse<WeightUnit[]>>("WeightUnit/GetAll");
        return data;
    };

}